import urlParser from 'url';

//
// Generates a pretty output for bytes.
//
//  bytes* (number) - The number of bytes to prettify.
//
// Returns a string.
//
export function prettyBytes(bytes) {
  bytes = parseInt(bytes);
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.max(0, Math.floor(Math.log(bytes) / Math.log(1024)));

  return bytes > 0 ? Math.round(bytes / Math.pow(1024, index)) + ' ' + units[index] : '0 B';
}

//
// Generates a title-cased, readable filename from a filename.
//
//  filename* (string) - The filename to prettify.
//
// Returns a string.
//
export function prettyFilename(filename) {
  // Remove extension
  return filename
    .replace(/\.[^/.]+$/, '') // remove extension
    .replace(/(-|_)/g, ' ') // convert dashes and underscores to spaces
    .replace(/\s\s+/g, ' ') // remove duplicate spaces
    .split(' ') // title case
    .map(s => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
    .join(' ');
}

//
// Genrates a pretty URL from a URL.
//
//  url* (string) - The URL to prettify.
//
// Returns a string.
//
export function prettyURL(url) {
  url = urlParser.parse(url);
  const host = (url.host || '').replace(/^www\./i, '');
  const path = url.pathname || '';
  return (host + path).replace(/\/+$/, '');
}
